import { FC } from "react";

import { MenuItem } from "services/app/types";

interface MenuItemProps {
  menuItem: MenuItem;
}

const HeaderItem: FC<MenuItemProps> = ({ menuItem }) => {
  return (
    <li>
      <a
        href={(menuItem.domain || "") + menuItem.path}
        className="text -nav -dark"
      >
        {menuItem.name}
      </a>
    </li>
  );
};

export default HeaderItem;
